import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const DanceStudio = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my dance studio business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps dance studio businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for dance studio businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most dance studio businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my dance studio business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like dance studio. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Dance Studio - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Dance Studio CRM", url: "/industries/dance-studio" }
  ];

  const industryData = {
    name: 'Dance Studio',
    title: 'Fill Classes & Keep Dancers Engaged Year-Round',
    subtitle: 'Automate class enrollment, reduce dropouts, and manage recitals without the chaos',
    icon: '💃',
    challenges: [
      'Classes don\'t fill consistently',
      'Students quit mid-season',
      'Recital coordination is overwhelming',
      'Hard to manage costume orders',
      'Summer enrollment drops off'
    ],
    solutions: [
      'Automated enrollment campaigns',
      'Engagement and retention programs',
      'Recital management system',
      'Costume order tracking',
      'Summer intensive promotion'
    ],
    features: [
      'Student CRM with class tracking',
      'Class enrollment automation',
      'Recital coordination',
      'Costume management',
      'Performance video sharing',
      'Payment automation',
      'Attendance tracking',
      'Review requests'
    ],
    results: [
      '85% class capacity',
      '70% retention through full season',
      '3x summer intensive enrollment',
      '5.2K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Dance Studio UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for dance studio businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for dance studio UK, dance studio business software, dance studio customer management, dance studio lead generation UK"
        url="/industries/dance-studio"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default DanceStudio;